var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3V17C0 18.6569 1.34315 20 3 20H13C14.6569 20 16 18.6569 16 17V7C16 5.34315 14.6569 4 13 4H1C0.447715 4 0 3.55228 0 3ZM3.25 10C3.25 9.58579 3.58579 9.25 4 9.25H12C12.4142 9.25 12.75 9.58579 12.75 10C12.75 10.4142 12.4142 10.75 12 10.75H4C3.58579 10.75 3.25 10.4142 3.25 10ZM3.25 13.5C3.25 13.0858 3.58579 12.75 4 12.75H9.5C9.91421 12.75 10.25 13.0858 10.25 13.5C10.25 13.9142 9.91421 14.25 9.5 14.25H4C3.58579 14.25 3.25 13.9142 3.25 13.5Z",
    fill: "#475467"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.408785 2.0871C0.757267 2.24338 1 2.59334 1 3H13C13.3453 3 13.6804 3.04375 14 3.12602V2.30604C14 1.08894 12.922 0.154017 11.7172 0.326141L0.919595 1.86865C0.727121 1.89615 0.552706 1.97374 0.408785 2.0871Z",
    fill: "#00546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsActive);
export default __webpack_public_path__ + "static/media/DocumentsActive.e996b4903f8f5cf75aac9cd438f68cb4.svg";
export { ForwardRef as ReactComponent };